import PropTypes from "prop-types";
import classnames from "classnames";

import Icon from "../Icon";

import "./alert.scss";

const Alert = ({ type, className, children }) => {
  return (
    <div
      className={classnames("alert", className, { [`alert--${type}`]: type })}
    >
      <Icon
        name={type === "success" ? "system-checkmark" : "system-warning"}
        theme={type === "success" ? "success" : "error"}
        size="medium"
      />
      <span>{children}</span>
    </div>
  );
};

Alert.propTypes = {
  type: PropTypes.oneOf(["success", "error"]).isRequired,
  className: PropTypes.string,
  children: PropTypes.node,
};

Alert.defaultProps = {
  type: "success",
};

export default Alert;
